import styled from 'styled-components';
import SvgSpinner from '../../../others/svg_dist/Spinner';

export const Wrapper = styled.div`
	background-image: linear-gradient(45deg, #002962, #004583);
	width: 100%;
	padding: 20px 0;
	position: relative;
	margin-bottom: 100px;
	padding-bottom: 0;
	scroll-margin-top: 200px;
`;

export const CodeContainer = styled.div`
	width: 600px;
	margin: 30px auto;
	background-color: #011e54;
	border-radius: 10px;
	padding: 40px 10px;
	margin-bottom: 0;
	@media screen and (max-width: 800px) {
		width: 98%;
	}
`;

export const InputWrapper = styled.div`
	position: relative;
	width: 250px;
	margin: 0 auto;
	margin-top: 30px;
	input {
		all: unset;
		width: 100%;
		height: 45px;
		border: 2px solid #fff;
		color: #fff;
		text-align: center;
		border-radius: 5px;
		font-size: 16px;
		font-weight: 600;
		letter-spacing: 3px;
	}
`;

export const InputButton = styled.div`
	position: absolute;
	width: 30px;
	height: 30px;
	border: 2px solid #0c619b;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	top: 50%;
	right: 0;
	transform: translate(-15%, -50%);
	cursor: pointer;
	svg {
		fill: #fff;
		width: 15px;
		height: 15px;
	}
`;

export const HeadingTopFont = styled.p`
	color: #fff;
	font-size: 18px;
	font-weight: 600;
	text-align: center;
	margin: 0px;
	line-height: 1.3;
`;

export const HeadingBottomFont = styled.p`
	color: #fff;
	text-align: center;
	margin: 0px;
	font-size: 12px;
`;

export const ButtonsContainer = styled.div`
	background-image: linear-gradient(180deg, #0161a2, #004583);
	width: 70%;
	margin: 0 auto;
	transform: translateY(calc(50% + 20px));
	height: 120px;
	border-radius: 150px;
	display: flex;
	align-items: center;
	justify-content: center;
	@media screen and (max-width: 800px) {
		width: 95%;
		flex-flow: column nowrap;
		height: 140px;
		& > div:nth-child(1) {
			margin: 5px 0 10px !important;
		}
	}
	@media screen and (max-width: 550px) {
		width: 100%;
		border-radius: 10px;
	}
`;

export const ErrorFont = styled.p`
	text-align: center;
	margin: 0 auto;
	margin-top: 8px;
	margin-bottom: -21px;
	color: #ff1212;
`;

export const StyledSpinnerSvg = styled(SvgSpinner)`
	@keyframes Spin {
		0% {
			rotate: 0deg;
		}
		95% {
			rotate: 360deg;
		}
		100% {
			rotate: 360deg;
		}
	}
	animation: Spin infinite;
	animation-delay: 0;
	animation-duration: 1200ms;
	width: 30px;
	height: 30px;
	top: 10px !important;
	transform: unset !important;
`;
